// extracted by mini-css-extract-plugin
export default {"icon":"AntdTable_icon__XTj5F","icon__expanded":"AntdTable_icon__expanded__bLzRj"};